(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["addon-reminder-popup"] && !Shopify.designMode) return;
  try {
    class AddonReminderPopup extends ModalDialog {
    constructor() {
      super();
      this.cta = this.querySelector('[data-addon-reminder-cta]');
      this.cta.addEventListener('click', this.onAddClick.bind(this));
    }

    showForOffer(offer) {
      this.offer = offer;

      this.querySelector('[data-addon-reminder-heading]').textContent =
        replaceMoneyTokens(offer.popupHeading, offer) || ('Don’t forget: ' + offer.addonTitle);
      this.querySelector('[data-addon-reminder-copy]').textContent = replaceMoneyTokens(offer.popupBody, offer) || '';
      this.querySelector('[data-addon-reminder-savings]').textContent = replaceMoneyTokens(offer.savingsLabel, offer) || '';
      this.cta.textContent = replaceMoneyTokens(offer.popupCta, offer) || 'Add to cart';

      const img = this.querySelector('[data-addon-reminder-image]');
      if (offer.addonImage) {
        img.src = offer.addonImage;
        img.alt = offer.addonTitle || '';
      } else {
        img.removeAttribute('src');
      }

      this.show(document.activeElement);
    }

    onAddClick() {
      if (!this.offer || typeof addItemById !== 'function') return;
      this.cta.setAttribute('aria-disabled', 'true');
      addItemById(this.offer.variantId, 1, { _addon_source: 'reminder_popup' })
        .then((result) => {
          // addItemById's own docstring warns it "does not check available
          // products first" - on failure (e.g. a regional-warehouse stock
          // race condition) it resolves rather than rejects, with Shopify's
          // error body in result.item (status/description), matching the
          // same shape product-form.js's onSubmitHandler already checks.
          if (result && result.item && result.item.status) {
            console.error('Add-on could not be added to cart:', result.item.description || result.item.message);
            return;
          }
          this.hide();
        })
        .catch((error) => {
          console.error('Error adding add-on from reminder popup:', error);
        })
        .finally(() => this.cta.removeAttribute('aria-disabled'));
    }
  }

  customElements.define('addon-reminder-popup', AddonReminderPopup);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-addon-toggle"] && !Shopify.designMode) return;
  try {
    (function () {
    function formatAddonMoney(cents) {
      return typeof customFormatMoney === 'function'
        ? customFormatMoney(cents, window.moneyFormat)
        : cents;
    }

    // Returns null (not an empty object) when the slot has no active offer,
    // so callers can use a simple truthiness check.
    function readOfferData(toggle) {
      const row = toggle.closest('[data-addon-offer-row]');
      const jsonEl = row && row.querySelector('[data-addon-offer-json]');
      if (!jsonEl) return null;
      try {
        const data = JSON.parse(jsonEl.textContent);
        return Object.keys(data).length ? data : null;
      } catch (e) {
        return null;
      }
    }

    function readAllOffers(group) {
      const jsonEl = group.querySelector('[data-addon-offers-json]');
      if (!jsonEl) return [];
      try {
        return JSON.parse(jsonEl.textContent) || [];
      } catch (e) {
        return [];
      }
    }

    function pickMatchingOffer(offers, currentVariantId) {
      return (
        offers.find((offer) => {
          const ids = offer.targetVariantIds || [];
          return !ids.length || ids.map(String).includes(currentVariantId);
        }) || null
      );
    }

    // Fills the single slot's media/label/savings from the active offer,
    // resolving any "{$N}" / "{price}" money tokens (see replaceMoneyTokens
    // in global.js) for the shopper's current presentment currency. Hides
    // the slot entirely (resetting the Add/Skip
    // choice back to Skip) if no offer currently applies to the selected
    // variant - this never removes the slot from the layout mid-interaction
    // in a way that shifts surrounding content more than once, since it's
    // always the same node.
    function renderActiveOffer(row, offer) {
      const offerJsonEl = row.querySelector('[data-addon-offer-json]');
      const toggle = row.querySelector('[data-addon-toggle]');
      const skipToggle = row.querySelector('[data-addon-skip]');
      const mediaWrap = row.querySelector('[data-addon-media-wrap]');
      const mediaImg = row.querySelector('[data-addon-media-img]');
      const labelEl = row.querySelector('[data-addon-label]');
      const savingsEl = row.querySelector('[data-addon-savings]');

      if (!offer) {
        row.classList.add('is-hidden');
        if (toggle) toggle.checked = false;
        if (skipToggle) skipToggle.checked = true;
        if (offerJsonEl) offerJsonEl.textContent = '{}';
        return;
      }

      row.classList.remove('is-hidden');
      if (offerJsonEl) offerJsonEl.textContent = JSON.stringify(offer);

      if (labelEl) labelEl.textContent = replaceMoneyTokens(offer.toggleLabel, offer) || '';
      if (savingsEl) {
        const savingsText = replaceMoneyTokens(offer.savingsLabel, offer) || '';
        savingsEl.textContent = savingsText;
        savingsEl.classList.toggle('is-hidden', !savingsText);
      }

      if (mediaWrap && mediaImg) {
        if (offer.addonImage) {
          mediaImg.src = offer.addonImage;
          mediaWrap.classList.remove('is-hidden');
        } else {
          mediaWrap.classList.add('is-hidden');
        }
      }
    }

    function getBasePriceCents(productMain) {
      const jsonEl = document.querySelector('.js-product-json');
      if (!jsonEl || !productMain || !productMain.opts) return null;
      try {
        const product = JSON.parse(jsonEl.textContent).product;
        const variantId = String(productMain.opts.state.id);
        const variant = product.variants.find((v) => String(v.id) === variantId);
        return variant ? variant.price : null;
      } catch (e) {
        return null;
      }
    }

    function recomputeAtcPrice(productForm, productMain) {
      const priceEl = productForm.querySelector('[data-addon-atc-price]');
      if (!priceEl) return;

      const basePrice = getBasePriceCents(productMain);
      if (basePrice === null) return;

      const checkedToggles = productForm.querySelectorAll('[data-addon-toggle]:checked');
      if (!checkedToggles.length) {
        priceEl.innerHTML = formatAddonMoney(basePrice);
        return;
      }

      let combined = basePrice;
      checkedToggles.forEach((toggle) => {
        const offer = readOfferData(toggle);
        if (!offer) return;
        combined += computeAddonNetCents(offer);
      });

      priceEl.innerHTML = formatAddonMoney(Math.max(combined, 0));
    }

    function updateActiveOffer(productForm, productMain) {
      if (!productMain || !productMain.opts) return;
      const group = productForm.querySelector('[data-addon-toggle-group]');
      const row = group && group.querySelector('[data-addon-offer-row]');
      if (!group || !row) return;

      const offers = readAllOffers(group);
      const currentVariantId = String(productMain.opts.state.id);
      renderActiveOffer(row, pickMatchingOffer(offers, currentVariantId));
    }

    function initAddonToggles(productForm) {
      const productMain = productForm.closest('product-main');
      if (!productMain) return;

      const recompute = () => recomputeAtcPrice(productForm, productMain);
      const onVariantUpdate = () => {
        updateActiveOffer(productForm, productMain);
        recompute();
      };

      // Delegated on the row (not just the "Add" radio) so a click on
      // either the "Add" or "Skip" button triggers a recompute - 'change'
      // only fires on the radio the shopper actually clicked, and that
      // isn't always the one carrying [data-addon-toggle].
      const row = productForm.querySelector('[data-addon-offer-row]');
      if (row) row.addEventListener('change', recompute);

      if (productMain.opts && typeof productMain.opts.onUpdate === 'function') {
        productMain.opts.onUpdate(onVariantUpdate);
      }

      onVariantUpdate();
    }

    function init() {
      document.querySelectorAll('product-form').forEach((productForm) => {
        if (productForm.querySelector('[data-addon-toggle-group]')) {
          initAddonToggles(productForm);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["regional-bis-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    class RegionalBisModal extends ModalDialog {
      constructor() {
        super();
        this.form = this.querySelector('[data-rb-form]');
        this.titleEl = this.querySelector('[data-rb-title]');
        this.variantWrapper = this.querySelector('[data-rb-variant-wrapper]');
        this.variantSelect = this.querySelector('[data-rb-variant-select]');
        this.emailInput = this.querySelector('input[name="email"]');
        this.submitBtn = this.querySelector('[data-rb-submit]');
        this.submitCopy = this.querySelector('[data-rb-submit-copy]');
        this.successEl = this.querySelector('[data-rb-success]');
        this.successCopy = this.querySelector('[data-rb-success-copy]');
        this.errorEl = this.querySelector('[data-rb-error]');
        this.errorCopy = this.querySelector('[data-rb-error-copy]');
        this.data = JSON.parse(this.querySelector('[data-rb-json]').textContent);
        this.defaultSubmitCopy = this.submitCopy.textContent;
        this.defaultErrorCopy = this.errorCopy.textContent;

        this.form.addEventListener('submit', this.handleSubmit.bind(this));
        // ModalDialog's own backdrop-click handler only matches its literal
        // <modal-dialog> tag name, so it never fires for this custom tag.
        this.addEventListener('click', (e) => {
          if (e.target === this) this.hide();
        });
      }

      show(opener) {
        super.show(opener);
        this.resetMessages();
        this.populate();
        if (this.data.variants.length === 0) {
          // Every variant is back in stock (a stale trigger fired after a
          // restock, before the page re-checked availability) — there's
          // nothing left to notify on.
          this.form.hidden = true;
          this.errorCopy.textContent = 'This item is back in stock.';
          this.errorEl.hidden = false;
        } else {
          this.emailInput.focus();
        }
      }

      populate() {
        const { product, variants, selectedVariantId } = this.data;
        this.titleEl.textContent = product.title;

        const mainOptionSelect = document.querySelector('[data-option-main]');
        const requestedVariantId = mainOptionSelect && mainOptionSelect.value
          ? Number(mainOptionSelect.value)
          : selectedVariantId;

        // this.data.variants is already filtered server-side to out-of-stock
        // options only. If the page's active variant isn't one of them, fall
        // back to the first out-of-stock option instead of pointing the
        // alert at a variant that's actually available.
        const activeVariantId = variants.some((v) => v.id === requestedVariantId)
          ? requestedVariantId
          : (variants[0] && variants[0].id);

        this.activeVariantId = activeVariantId;

        if (this.data.hasOnlyDefaultVariant) {
          this.variantWrapper.classList.add('is-hidden');
        } else {
          this.variantSelect.innerHTML = variants
            .map((variant) => `<option value="${variant.id}">${variant.title}</option>`)
            .join('');
          this.variantSelect.value = activeVariantId;
          this.variantWrapper.classList.remove('is-hidden');
        }
      }

      resetMessages() {
        this.successEl.hidden = true;
        this.errorEl.hidden = true;
        this.form.hidden = false;
      }

      handleSubmit(event) {
        event.preventDefault();

        const variantId = this.data.hasOnlyDefaultVariant
          ? this.activeVariantId
          : Number(this.variantSelect.value);
        const variant = this.data.variants.find((v) => v.id === variantId) || {};

        const payload = {
          email: this.emailInput.value.trim(),
          variant_id: variantId,
          variant_title: variant.title || '',
          variant_image: variant.image || '',
          variant_url: variant.url || this.data.product.url,
          product_id: this.data.product.id,
          product_title: this.data.product.title,
          product_handle: this.data.product.handle,
          product_url: this.data.product.url,
          warehouse: this.data.warehouse,
          market: this.data.market,
          shop: this.data.shop,
          timestamp: new Date().toISOString(),
        };

        this.submitBtn.disabled = true;
        this.submitCopy.textContent = '…';
        this.errorEl.hidden = true;

        // A plain POST with a text/plain body avoids a CORS preflight (Apps
        // Script has no doOptions to answer one), and script.google.com adds
        // Access-Control-Allow-Origin itself, so the JSON response is
        // readable without mode: 'no-cors'.
        fetch(this.data.webhookUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify(payload),
        })
          .then((res) => res.json().catch(() => ({ status: res.status })))
          .then((data) => {
            const succeeded = data && data.status >= 200 && data.status < 300;
            if (succeeded) {
              this.successCopy.textContent = `We'll be in touch as soon as ${this.data.product.title} becomes available.`;
              this.successEl.hidden = false;
              this.form.hidden = true;
            } else {
              this.errorCopy.textContent = (data && data.message) || this.defaultErrorCopy;
              this.errorEl.hidden = false;
            }
          })
          .catch(() => {
            this.errorCopy.textContent = this.defaultErrorCopy;
            this.errorEl.hidden = false;
          })
          .finally(() => {
            this.submitBtn.disabled = false;
            this.submitCopy.textContent = this.defaultSubmitCopy;
          });
      }
    }

    if (!customElements.get('regional-bis-modal')) {
      customElements.define('regional-bis-modal', RegionalBisModal);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["teaser-popup"] && !Shopify.designMode) return;
  try {
    (function () {
        // Verify this revision against developers.klaviyo.com before changing.
        var KLAVIYO_API_REVISION = '2024-10-15';

        function safeGet(key) {
          try {
            return window.localStorage.getItem(key);
          } catch (e) {
            return null;
          }
        }

        function safeSet(key, value) {
          try {
            window.localStorage.setItem(key, value);
          } catch (e) {
            /* no-op: storage unavailable (private mode, quota, etc.) */
          }
        }

        function pushDataLayer(payload) {
          if (window.dataLayer) window.dataLayer.push(payload);
        }

        class WwTeaserPopup extends ModalDialog {
          constructor() {
            super();
            this.config = JSON.parse(this.querySelector('[data-ww-teaser-json]').textContent);
            this.dialogEl = this.querySelector('[role="dialog"]');
            this.form = this.querySelector('[data-ww-teaser-form]');
            this.emailInput = this.querySelector('[data-ww-teaser-email]');
            this.honeypotInput = this.querySelector('[data-ww-teaser-honeypot]');
            this.submitBtn = this.querySelector('[data-ww-teaser-submit]');
            this.submitCopy = this.querySelector('[data-ww-teaser-submit-copy]');
            this.statusEl = this.querySelector('[data-ww-teaser-status]');
            this.videoEl = this.querySelector('[data-ww-teaser-video]');
            this.audioToggle = this.querySelector('[data-ww-teaser-audio-toggle]');
            this.closeBtn = this.querySelector('[id^="ModalClose-"]');
            this.defaultSubmitCopy = this.submitCopy ? this.submitCopy.textContent : '';
            this.hasUnmuted = false;
            this.submittedKey = 'wwTeaser:' + this.config.handle + ':submitted';
            this.dismissedKey = 'wwTeaser:' + this.config.handle + ':dismissed';

            // Deliberately no backdrop-click-to-close: an accidental tap near
            // the edge (easy to do on mobile) would cost a real prospective
            // signup a full 24h dismissed-suppression window. Esc and the
            // close button remain as the two intentional ways to dismiss.

            // ModalDialog's own constructor already binds the close button via
            // this.querySelector('[id^="ModalClose-"]'), but that's a single
            // point of failure we don't control — belt-and-suspenders listener
            // directly on our own reference to it.
            if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.hide());

            if (this.form) this.form.addEventListener('submit', this.handleSubmit.bind(this));
            if (this.audioToggle) this.audioToggle.addEventListener('click', this.handleAudioToggle.bind(this));

            this.scheduleAutoOpen();
          }

          withinDateWindow() {
            var now = Date.now();
            if (this.config.startsAt) {
              var startsMs = new Date(this.config.startsAt).getTime();
              if (!isNaN(startsMs) && now < startsMs) return false;
            }
            if (this.config.endsAt) {
              var endsMs = new Date(this.config.endsAt).getTime();
              if (!isNaN(endsMs) && now > endsMs) return false;
            }
            return true;
          }

          scheduleAutoOpen() {
            // TEMP, testing-phase only: when the metaobject's testing_mode
            // checkbox is on, skip the submitted/dismissed localStorage gates
            // entirely so QA sees the popup on every reload. Remove this
            // field + the branch below once the popup is ready for production.
            if (!this.config.testingMode) {
              if (safeGet(this.submittedKey)) return;

              var dismissedAt = safeGet(this.dismissedKey);
              if (dismissedAt) {
                var elapsed = Date.now() - parseInt(dismissedAt, 10);
                if (!isNaN(elapsed) && elapsed < 24 * 60 * 60 * 1000) return;
              }
            }

            if (!this.withinDateWindow()) return;

            var delayMs = (this.config.delaySeconds || 3) * 1000;
            this.autoOpenTimer = window.setTimeout(() => {
              if (this.withinDateWindow()) this.show();
            }, delayMs);
          }

          show(opener) {
            super.show(opener);
            this.attachVideo();
            pushDataLayer({ event: 'teaser_popup_view', teaser: this.config.sourceLabel });
          }

          hide() {
            super.hide();
            if (this.videoEl) {
              this.videoEl.pause();
              this.videoEl.muted = true;
            }
            if (this.audioToggle) {
              this.audioToggle.setAttribute('aria-pressed', 'false');
              this.audioToggle.setAttribute('aria-label', 'Unmute video');
              this.audioToggle.setAttribute('data-audio-state', 'muted');
            }

            if (!this.submittedThisSession) {
              safeSet(this.dismissedKey, String(Date.now()));
            }
          }

          attachVideo() {
            if (!this.videoEl || !this.config.videoUrl) return;
            if (this.videoEl.dataset.attached) {
              this.videoEl.play().catch(() => {});
              return;
            }
            var source = document.createElement('source');
            source.src = this.config.videoUrl;
            source.type = 'video/mp4';
            this.videoEl.appendChild(source);
            this.videoEl.dataset.attached = 'true';
            this.videoEl.load();
            this.videoEl.muted = true;
            this.videoEl.play().catch(() => {});
          }

          handleAudioToggle() {
            if (!this.videoEl) return;
            var nextMuted = !this.videoEl.muted;
            this.videoEl.muted = nextMuted;

            var playAttempt = this.videoEl.play();
            if (playAttempt && typeof playAttempt.catch === 'function') {
              playAttempt.catch(() => {
                this.videoEl.muted = true;
                this.updateAudioToggleUI();
              });
            }

            this.updateAudioToggleUI();

            if (!this.videoEl.muted && !this.hasUnmuted) {
              this.hasUnmuted = true;
              pushDataLayer({ event: 'teaser_popup_unmute', teaser: this.config.sourceLabel });
            }
          }

          updateAudioToggleUI() {
            if (!this.audioToggle || !this.videoEl) return;
            var isMuted = this.videoEl.muted;
            this.audioToggle.setAttribute('aria-pressed', String(!isMuted));
            this.audioToggle.setAttribute('aria-label', isMuted ? 'Unmute video' : 'Mute video');
            this.audioToggle.setAttribute('data-audio-state', isMuted ? 'muted' : 'unmuted');
          }

          isValidEmail(value) {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
          }

          setStatus(message, state) {
            if (!this.statusEl) return;
            this.statusEl.textContent = message;
            if (state) {
              this.statusEl.setAttribute('data-state', state);
            } else {
              this.statusEl.removeAttribute('data-state');
            }
          }

          handleSubmit(event) {
            event.preventDefault();

            if (this.honeypotInput && this.honeypotInput.value) {
              // Likely a bot: pretend success, send nothing.
              this.onSubmitSucceeded();
              return;
            }

            var email = this.emailInput ? this.emailInput.value.trim() : '';
            if (!this.isValidEmail(email)) {
              this.setStatus('Please enter a valid email address.', 'error');
              if (this.emailInput) this.emailInput.focus();
              return;
            }

            var payload = {
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: this.config.sourceLabel,
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email: email,
                        properties: {
                          teaser_source: this.config.sourceLabel,
                          teaser_page: this.config.currentPath,
                          market: this.config.market,
                          locale: this.config.locale,
                        },
                      },
                    },
                  },
                },
                relationships: {
                  list: {
                    data: {
                      type: 'list',
                      id: this.config.klaviyoListId,
                    },
                  },
                },
              },
            };

            this.submitBtn.disabled = true;
            if (this.submitCopy) this.submitCopy.textContent = '…';
            this.setStatus('', null);

            fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(this.config.klaviyoPublicKey), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                revision: KLAVIYO_API_REVISION,
              },
              body: JSON.stringify(payload),
            })
              .then((res) => {
                if (res.status === 202) {
                  this.onSubmitSucceeded();
                } else {
                  return res.text().then((text) => {
                    console.error('[teaser-popup] Klaviyo subscription failed', res.status, text);
                    this.onSubmitFailed();
                  });
                }
              })
              .catch((error) => {
                console.error('[teaser-popup] Klaviyo subscription network error', error);
                this.onSubmitFailed();
              })
              .finally(() => {
                this.submitBtn.disabled = false;
                if (this.submitCopy) this.submitCopy.textContent = this.defaultSubmitCopy;
              });
          }

          onSubmitSucceeded() {
            this.submittedThisSession = true;
            safeSet(this.submittedKey, '1');
            this.setStatus(this.config.successMessage, 'success');
            if (this.form) this.form.hidden = true;
            pushDataLayer({ event: 'teaser_popup_submit', teaser: this.config.sourceLabel });
            // No auto-close: the submitted flag already prevents this popup
            // from reappearing, so there's no resubmission risk — only the
            // risk of a shopper missing the success message because it
            // vanished before they read it. Let them dismiss it themselves
            // (close button or Esc).
          }

          onSubmitFailed() {
            this.setStatus('Something went wrong. Please try again.', 'error');
          }
        }

        if (!customElements.get('ww-teaser-popup')) {
          customElements.define('ww-teaser-popup', WwTeaserPopup);
        }
      })();
  } catch(e) { console.error(e); }
})();

})();
